import { render } from "./sharepointFiles.vue?vue&type=template&id=a5d99886&scoped=true"
import script from "./sharepointFiles.vue?vue&type=script&lang=js"
export * from "./sharepointFiles.vue?vue&type=script&lang=js"

import "./sharepointFiles.vue?vue&type=style&index=0&id=a5d99886&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d99886"]])

export default __exports__